export default "__VITE_ASSET__875927ba__"